/**
 * Created by slava on 02.02.17.
 */

cleverapps.User = function (isNewUser) {
    cleverapps.EventEmitter.call(this);

    this.currentPhysicalLevel = {
        episode: 0,
        level: 0,
        progress: 0
    };

    this.progressCompare = 0;
    this.gold = 0;
    this.soft = 0;
    this.registered = Date.now();
    this.visited = Date.now();

    this.firstSession = isNewUser;

    this.onCantTakeGold = function () {
        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_DISABLED) {
            cleverapps.notification.create(Messages.get("NotEnoughCoins"));
            return;
        }

        cleverapps.focusManager.display({
            stack: true,
            focus: "ShopWindowNoGold",
            control: "MenuBarGoldItem",
            action: function (f) {
                new HardCurrencyShopWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    };

    if (!isNewUser) {
        const info = cleverapps.dataLoader.load(DataLoader.TYPES.ID);
        this.loadData(info);
    }

    this.save();

    this.updateIDFA();

    cleverapps.whenAllInitialized(() => {
        this.sendWelcomePush();
    });

    connector.metrics.on("startDay", this.onStartDay.bind(this));
    connector.metrics.on("updateVisited", this.onUpdateVisited.bind(this));
};

cleverapps.User.prototype = Object.create(cleverapps.EventEmitter.prototype);
cleverapps.User.prototype.constructor = cleverapps.User;

cleverapps.User.prototype.onStartDay = function () {
    this.visited = Date.now();
    this.save();

    const daysSinceRegistration = this.getDaysSinceRegistration();

    if (connector.social.isLoggedIn()) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LOGGEDIN_DAU);
    }

    if (cleverapps.paymentsHistory.isPayer()) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.PAYER_DAU);
    }

    if (cleverapps.settings.avatar && cleverapps.settings.avatar !== cleverapps.settings.getDefaultAvatar()) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.CHANGED_AVATAR_DAU);
    }

    if (cleverapps.settings.nickname && cleverapps.settings.nickname !== cleverapps.settings.getDefaultNickname()) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.CHANGED_NICKNAME_DAU);
    }

    if (daysSinceRegistration === 0) {
        this.reportNewUser();
    }
};

cleverapps.User.prototype.onUpdateVisited = function (visited) {
    this.visited = visited;
    this.save(false);
};

cleverapps.User.prototype.updateMetrics = function () {
    connector._metrics.setVisited(this.visited);
    connector._metrics.setRegistered(this.registered);
    connector.metrics.setChannel(this.channel);
};

cleverapps.User.prototype.incProgressCompare = function (amount, onSaveUser) {
    amount = amount || 1;
    this.progressCompare += amount;
    if (!onSaveUser) {
        this.save();
    }
};

cleverapps.User.prototype.reportNewUser = function () {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.NEW_USERS_DAU);

    if (connector.platform.oneOf(connector.G5WINDOWS)) {
        connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.LEVEL_UP, { loggers: ["g5"] });
    }

    cleverapps.abExperiments.allLogEvent(connector.EVENTS.STATS.REGISTERED, { withFutureGroups: true });

    cleverapps.timeouts.setTimeout(() => {
        connector.conversions.trackEvent(cleverapps.EVENTS.CONVERSIONS.SESSION_5_MINUTES);
    }, cleverapps.parseInterval("5 minute"));

    const channel = this.channel || "";

    if (!channel) {
        return;
    }

    if (connector.platform.oneOf(connector.CLEVERAPPS) && channel.includes("goo")) {
        cleverapps.consoleStream.enable();
    }

    cleverapps.info.reportIP();
};

cleverapps.User.prototype.getDaysSinceRegistration = function (timestamp) {
    return connector.metrics.getDaysSinceRegistration(timestamp);
};

cleverapps.User.prototype.loadData = function (info) {
    const userId = info.id;

    if (userId) {
        connector.platform.setUserID(userId);
    }

    this.gold = info.gold || 0;
    this.registered = info.registered;
    this.loggedIn = info.loggedIn;
    this.guest = info.guest;

    if (typeof info.channel === "string") {
        info.channel = info.channel.substring(0, cleverapps.User.MAX_CHANNEL_LENGTH);

        if (info.channel.startsWith("storeBingAd_")) {
            info.channel = "bing";
        }
    }

    this.channel = info.channel;

    this.lastVisited = info.visited;
    this.visited = info.visited;

    ExpHelper.GetMainInstance().load(info.exp);

    this.idfa = info.idfa;

    this.progressCompare = info.progressCompare || 0;
    this.soft = info.soft || 0;

    // the cheater mark, true or undefined: set by FraudDetector here or by support via /setcheater/ (comes with the sync snapshot)
    this.cheater = info.cheater ? true : undefined;

    this.trigger("updateLeague", true);
};

cleverapps.User.prototype.setCheater = function (cheater) {
    if (this.cheater === cheater) {
        return;
    }

    this.cheater = cheater;
    this.save();
    this.trigger("updateCheater");
};

cleverapps.User.prototype.isBeginner = function () {
    return this.currentPhysicalLevel.episode <= 1;
};

cleverapps.User.prototype.isNovice = function () {
    return this.currentPhysicalLevel.episode <= 3 && this.currentPhysicalLevel.episode > 1;
};

cleverapps.User.prototype.isFirstSession = function () {
    return this.firstSession;
};

cleverapps.User.prototype.checkAvailable = function () {
    return true;
};

cleverapps.User.prototype.earnHard = function (eventName, value, silent) {
    if (value === 0) {
        return;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.EARN.HARD, { value, itemId: eventName });
    cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.EARN.HARD, { value });

    connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.EARN_HARD, { value });

    if (eventName === undefined) {
        cleverapps.throwAsync("undefined earn hard event");
    }

    if (eventName === cleverapps.EVENTS.EARN.PURCHASE) {
        cleverapps.abExperiments.allLogEvent(`${cleverapps.EVENTS.EARN.HARD}-${eventName}`, { value });
    }

    this.gold += value;
    this.incProgressCompare(3, true);
    this.save();

    if (!silent) {
        this.onChangeHard();
    }
};

cleverapps.User.prototype.onChangeHard = function (options) {
    this.trigger("changeHard", options);
};

cleverapps.User.prototype.canTakeHard = function (gold) {
    return this.gold >= gold;
};

cleverapps.User.prototype.spendHard = function (eventName, value, silent) {
    if (value === 0) {
        return true;
    }

    if (this.canTakeHard(value)) {
        cleverapps.eventBus.trigger("taskEvent", "SPEND_HARD", value);
        cleverapps.eventBus.trigger("spend_hard", value);

        cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.SPENT.HARD, { value });

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SPENT.HARD, { value, itemId: eventName });

        const currentGame = typeof Game !== "undefined" && Game.currentGame;
        const level = currentGame && currentGame.level;

        if (currentGame && currentGame.getMode() === GameBase.MODE_HIGHSCORE) {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.SPENT.HARD}-${currentGame.getMode()}`, { value });
        }

        if (level && level.isBonusWorldLevel && level.isBonusWorldLevel() || cleverapps.environment.isBonusWorldScene()) {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_BONUS_WORLD);
            if (mission) {
                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.SPENT.HARD}-${mission.bonusWorld.type}${eventName}`, { value });
            }
        }

        cleverapps.aims.showTarget(cleverapps.aims.getTarget("hard"));

        this.gold -= value;

        if (this.gold < 100 && this.gold + value >= 100) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.LOW_HARD, { value: this.gold, itemId: eventName });
        }

        this.incProgressCompare(3, true);
        this.save();

        cleverapps.pendingRewards.release("hard");

        if (!silent) {
            this.onChangeHard();
        }

        return true;
    }
    this.onCantTakeGold(value - this.gold);
    return false;
};

cleverapps.User.prototype.setSoft = function (soft, silent, options) {
    const diff = soft - this.soft;

    if (diff !== 0) {
        this.soft = soft;
        this.incProgressCompare(1, true);
        this.save();

        if (diff < 0) {
            cleverapps.pendingRewards.release("soft");
        }

        if (!silent) {
            this.trigger("changeSoft");
        }
    }

    if (diff > 0) {
        const eventName = options && options.event;
        if (eventName === undefined) {
            cleverapps.throwAsync("undefined earn soft event");
        }

        cleverapps.abExperiments.allLogEvent(`${cleverapps.EVENTS.EARN.SOFT}-${eventName}`, { value: diff });

        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.SOFT}-${eventName}`, { value: diff });

        connector.conversions.trackEvent(connector.EVENTS.CONVERSIONS.EARN_SOFT, diff);
    }
};

cleverapps.User.prototype.canTakeSoft = function (soft) {
    return this.soft >= soft;
};

cleverapps.User.prototype.onCantTakeSoft = function () {
    if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_DISABLED) {
        cleverapps.notification.create(Messages.get("NotEnoughCoins"));
        return;
    }

    cleverapps.focusManager.display({
        stack: true,
        focus: "ShopWindowNoSoft",
        control: ["MenuBarGoldItem", "MenuBarCoinsItem"],
        action: function (f) {
            new SoftCurrencyShopWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

cleverapps.User.prototype.spendSoft = function (eventName, soft, options) {
    options = options || {};
    if (!this.canTakeSoft(soft)) {
        this.onCantTakeSoft();
        return false;
    }

    this.setSoft(this.soft - soft);

    if (typeof Game !== "undefined" && Game.currentGame && Game.currentGame.getMode() === GameBase.MODE_HIGHSCORE) {
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.SPENT.SOFT}-${Game.currentGame.getMode()}`, { value: soft });
    }

    cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.SPENT.SOFT, { value: soft });

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.SPENT.SOFT}-${eventName}`, { value: soft });

    cleverapps.eventBus.trigger("taskEvent", "SPEND_SOFT", soft);
    cleverapps.effects.fire("ui.shop.buy");

    if (cleverapps.missionManager.findRunningMission(Mission.TYPE_SOFTFEAST)) {
        const reward = new RewardsList({
            mission: { amount: soft, missionType: Mission.TYPE_SOFTFEAST }
        });
        reward.receiveRewards();

        const location = cleverapps.meta.getSelectedLocation();
        if (location.locationConfig.isMain) {
            reward.collectRewardsAnimation(options.source, {
                withoutDelta: true
            });
        }
    }

    return true;
};

cleverapps.User.prototype.setLoggedIn = function (loggedIn) {
    this.loggedIn = loggedIn;
};

cleverapps.User.prototype.setGuest = function (guest) {
    this.guest = guest ? true : undefined;
    this.save();
};

cleverapps.User.prototype.getSaveInfo = function () {
    return {
        id: connector.platform.getUserID(),
        gold: this.gold,
        soft: this.soft,
        registered: this.registered,
        visited: this.visited,
        channel: this.channel,
        exp: ExpHelper.GetMainInstance().getExp(),
        idfa: this.idfa,
        cheater: this.cheater,
        progressCompare: this.progressCompare,
        loggedIn: this.loggedIn,
        guest: this.guest,
        version: cleverapps.config.version // need for migration from old clients on client and on server
    };
};

cleverapps.User.prototype.afterSync = function () {
    this.trigger("updateLeague", true);
};

cleverapps.User.prototype.save = function (updateServer) {
    if (updateServer === false) {
        this.afterSync();
    }

    cleverapps.dataLoader.save(DataLoader.TYPES.ID, this.getSaveInfo());

    if (updateServer !== false) {
        connector.synchronizer.addSendTask("users");
    }
};

cleverapps.User.prototype.setRandomBoostersReward = function (reward) {
    if (!reward.randomBoosters) {
        return reward;
    }

    reward.boosters = {};
    for (let i = 0; i < reward.randomBoosters.amount; i++) {
        const type = PseudoRandom.GET().choose(reward.randomBoosters.types);
        reward.boosters[type] = reward.boosters[type] ? reward.boosters[type] + 1 : 1;
    }
    delete reward.randomBoosters;
    return reward;
};

cleverapps.User.prototype.prepareRewardByRich = function (reward, minGold) {
    if (!reward.hard && !reward.boosters && !reward.randomBoosters) {
        return reward;
    }

    reward = cleverapps.clone(reward, true);
    reward = this.setRandomBoostersReward(reward);

    const lastPaymentTime = cleverapps.paymentsHistory.getLastPaymentTime();
    if (lastPaymentTime && lastPaymentTime > Date.now() - cleverapps.parseInterval("1 day")) {
        return reward;
    }

    let requireBoobyPrize = false;

    if (reward.hard) {
        let powerDecrease = true;
        if (lastPaymentTime && lastPaymentTime > Date.now() - cleverapps.parseInterval("3 day")) {
            powerDecrease = false;
        }

        let goldCoef = 1;
        if (this.gold >= 1000 && powerDecrease) {
            goldCoef = 0.1;
            requireBoobyPrize = true;
        } else if (this.gold >= 600) {
            requireBoobyPrize = true;
            goldCoef = 0.25;
        } else if (this.gold >= 300) {
            goldCoef = 0.5;
        }

        reward.hard = Math.max(Math.ceil(reward.hard * goldCoef / 5) * 5, minGold || 0);
    }

    if (requireBoobyPrize) {
        let boobyPrizes = [];

        if (cleverapps.config.type === "match3") {
            if (cleverapps.starChest && cleverapps.starChest.isEnabled()) {
                boobyPrizes = [{
                    stars: 3,
                    exp: 1
                }, {
                    stars: 3
                }, {
                    stars: 2,
                    exp: 1
                }, {
                    exp: 2
                }];
            } else {
                boobyPrizes = [{
                    exp: 1
                }, {
                    exp: 1
                }, {
                    exp: 2
                }];
            }
        }

        if (!reward.unlimitedLives && cleverapps.lives) {
            boobyPrizes = boobyPrizes.concat([{
                unlimitedLives: "10 minutes"
            }, {
                unlimitedLives: "15 minutes"
            }, {
                unlimitedLives: "30 minutes"
            }]);
        }

        if (boobyPrizes.length > 0) {
            const booby = PseudoRandom.GET().choose(boobyPrizes);
            for (const key in booby) {
                if (!reward[key]) {
                    reward[key] = booby[key];
                } else {
                    reward[key] += booby[key];
                }
            }
        }
    }

    return reward;
};

cleverapps.User.prototype.isReturnedPlayer = function () {
    return this.lastVisited && (this.lastVisited + cleverapps.parseInterval("2 week")) < Date.now();
};

cleverapps.User.prototype.calcChannel = function (callback) {
    callback = callback || function () {};

    const found = (channel, payload) => {
        this.setChannel(channel);
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.ENTRY_PAYLOAD, { details: payload });
        callback();
    };

    new ActionPlayer([
        (f) => connector.platform.parsePayload((payload) => {
            const channel = payload && payload.channel;
            channel ? found(channel, payload) : f();
        }),

        (f) => connector.platform.calcPromo((promo) => {
            promo ? found(promo, { promo }) : f();
        })
    ]).play(callback);
};

cleverapps.User.prototype.setChannel = function (channel) {
    channel = channel.substring(0, cleverapps.User.MAX_CHANNEL_LENGTH);

    if (this.channel !== channel) {
        this.channel = channel;
        this.save();
    }

    connector.metrics.setChannel(this.channel);
};

cleverapps.User.prototype.updateIDFA = function () {
    const idfa = connector.info.deviceID;

    if (!idfa || this.idfa === idfa) {
        return;
    }

    console.log(`user set idfa - ${this.idfa}`);
    this.idfa = idfa;
    cleverapps.dataLoader.save(DataLoader.TYPES.ID, this.getSaveInfo());

    cleverapps.RestClient.post(
        `/users/idfa/${connector.platform.getUserID()}`,
        { idfa: this.idfa }
    );
};

cleverapps.User.prototype.initializeNewPlayerGold = function () {
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        this.gold = 15;
    }
    this.gold = 0;
};

cleverapps.User.prototype.initializeNewPlayerSoft = function () {
    this.soft = 0;
    if (["merge", "merge2"].includes(cleverapps.config.type)) {
        this.soft = 100;
    }
    if (cleverapps.config.type === "battlefield") {
        this.soft = 30;
    }
};

cleverapps.User.prototype.initializeNewPlayer = function () {
    this.initializeNewPlayerGold();
    this.initializeNewPlayerSoft();

    ExpHelper.GetMainInstance().load(0);
    this.save();

    this.trigger("updateLeague");
};

cleverapps.User.prototype.sendLetsPlayPush = cleverapps.throttle(1000, () => {
    Object.keys(PUSHES).forEach((key) => {
        if (!key.startsWith("LETS_PLAY_")) {
            return;
        }

        let timeout = `${key.replace("LETS_PLAY_", "")} days`;

        if (cleverapps.config.name === "scramble" && connector.platform.oneOf(connector.INSTANT) && key === "LETS_PLAY_1") {
            timeout = "10 minutes";
        }

        PushHelper.sendPush(PUSHES[key], cleverapps.parseInterval(timeout));
    });
});

cleverapps.User.prototype.sendWelcomePush = function () {
    if (!this.isFirstSession()) {
        return;
    }

    const timeout = cleverapps.parseInterval("5 minutes");
    let lastSend = 0;

    const sendWelcome = function () {
        lastSend = Date.now();
        PushHelper.sendPush(PUSHES.WELCOME, timeout);
    };

    connector.social.on("login", sendWelcome);

    sendWelcome();

    cleverapps.timeouts.setInterval(() => {
        if (lastSend + timeout > Date.now()) {
            sendWelcome();
        }
    }, cleverapps.parseInterval("2 minutes"));
};

cleverapps.User.ON_SHOW_CHANGE_VISITED = "1 hour";

cleverapps.User.SOFT_CURRENCY = 0;
cleverapps.User.HARD_CURRENCY = 1;
cleverapps.User.HARD_TO_SOFT = 4.17;

cleverapps.User.MAX_CHANNEL_LENGTH = 100;
